<template>
    <div>
        <div class="btn-group mb-3">
            <button
                type="button"
                class="btn btn-light"
                :class="{ 'active': section === 'deliveries' || section === 'not_delivered' }"
                @click="section = 'deliveries'"
            >Inlösen / Prodorder</button>
            <button
                type="button"
                class="btn btn-light"
                :class="{ 'active': section === 'returnorders_deliveries' || section === 'returnorders_not_delivered' }"
                @click="section = 'returnorders_deliveries'"
            >Reklamation / Returorder</button>
            <button
                type="button"
                class="btn btn-light"
                :class="{ 'active': section === 'card_orders' }"
                @click="section = 'card_orders'"
            >Ordrar / Kortbeställningar</button>
        </div>

        <div v-if="section === 'deliveries'" class="card" style="max-width: 900px;">
            <div class="card-header bg-white">
                <h5 class="card-title">Inlösen - Leveranser (senaste året)</h5>
            </div>
            <div class="card-body">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" :class="{ 'active': section === 'deliveries' }" @click="section = 'deliveries'">Leveranser</button>
                    <button type="button" class="btn btn-light" :class="{ 'active': section === 'not_delivered' }" @click="section = 'not_delivered'">Ej levererade</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th>Leveransstatus</th>
                            <th>Produkt</th>
                            <th class="text-right">Antal</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="busy">
                        <tr>
                            <td colspan="4" class="text-center py-5"><i class="icon-spinner2 spinner"></i></td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="deliveries && Object.keys(deliveries).length > 0">
                        <template v-for="(items, week) in deliveries">
                            <tr :key="'w-' + week">
                                <th colspan="4">{{ week }}</th>
                            </tr>
                            <tr v-for="(item, i_index) in items" :key="'li-' + week + '-' + i_index" :style="item.Style" :class="{ 'bg-success-100': item.isDelivered, 'bg-warning-100': !item.isDelivered }">
                                <td>
                                    {{ item.StatusID }}:{{ item.Status }}<span v-if="!item.isDelivered" class="ml-1">[EJ LEVERERAD]</span>
                                </td>
                                <td>
                                    #{{ item.ProdID }} - {{ item.ProdName }}
                                </td>
                                <td class="text-right">
                                    {{ item.Antal }}
                                </td>
                                <td class="text-right">
                                    <a
                                        :href="'/batch/list?type=prod_order&status_id=' + item.StatusID + '&prod_id=' + item.ProdID + '&yearweek=' + item.vecka"
                                        target="_blank"
                                    >
                                        Lista &#187;
                                    </a>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="4" class="text-center py-5"><i>Inga leveranser...</i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else-if="section === 'not_delivered'" class="card">
            <div class="card-header bg-white">
                <h5 class="card-title">Inlösen - Ej levererade</h5>
            </div>
            <div class="card-body">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" :class="{ 'active': section === 'deliveries' }" @click="section = 'deliveries'">Leveranser</button>
                    <button type="button" class="btn btn-light" :class="{ 'active': section === 'not_delivered' }" @click="section = 'not_delivered'">Ej levererade</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Orderdatum</th>
                            <th>Kortnummer</th>
                            <th>Namn</th>
                            <th>Önskat Lev. datum</th>
                            <th>Beställd produkt</th>
                            <th>Ordertatus</th>
                        </tr>
                    </thead>
                    <tbody v-if="busy">
                        <tr>
                            <td colspan="4" class="text-center py-5"><i class="icon-spinner2 spinner"></i></td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="not_delivered && not_delivered.length > 0">
                        <tr v-for="(item, i_index) in not_delivered" :key="'ni-' + i_index" style="color: white;" :class="['bg-' + item.Class]">
                            <td>
                                <a
                                    :href="'/prodorders/' + item.ProdOrderID"
                                    target="_blank"
                                    style="color: white;"
                                >
                                    {{ item.ProdOrderID }}
                                </a>
                            </td>
                            <td>{{ item.OrderTS }}</td>
                            <td>
                                <a
                                    :href="'/prodorders/' + item.ProdOrderID"
                                    target="_blank"
                                    style="color: white;"
                                >
                                    {{ item.CardNo }}
                                </a>
                            </td>
                            <td>{{ item.Name }}</td>
                            <td>{{ item.WantedDeliveryDate }}</td>
                            <td>{{ item.ProdQuantity }} st #{{ item.ProdID }} - {{ item.ProdName }}</td>
                            <td>{{ item.Status }} ({{ item.StatusID }})</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="7" class="text-center py-5"><i>Inga leveranser...</i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="section === 'returnorders_deliveries'" class="card" style="max-width: 900px;">
            <div class="card-header bg-white">
                <h5 class="card-title">Reklamationer - Leveranser (senaste året)</h5>
            </div>
            <div class="card-body">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" :class="{ 'active': section === 'returnorders_deliveries' }" @click="section = 'returnorders_deliveries'">Leveranser</button>
                    <button type="button" class="btn btn-light" :class="{ 'active': section === 'returnorders_not_delivered' }" @click="section = 'returnorders_not_delivered'">Ej levererade</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th>Leveransstatus</th>
                            <th>Produkt</th>
                            <th class="text-right">Antal</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="busy">
                        <tr>
                            <td colspan="4" class="text-center py-5"><i class="icon-spinner2 spinner"></i></td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="returnorders_deliveries && Object.keys(returnorders_deliveries).length > 0">
                        <template v-for="(items, week) in returnorders_deliveries">
                            <tr :key="'w-' + week">
                                <th colspan="4">{{ week }}</th>
                            </tr>
                            <tr v-for="(item, i_index) in items" :key="'li-' + week + '-' + i_index" :style="item.Style" :class="{ 'bg-success-100': item.isDelivered, 'bg-warning-100': !item.isDelivered }">
                                <td>
                                    {{ item.StatusID }}:{{ item.Status }}<span v-if="!item.isDelivered" class="ml-1">[EJ LEVERERAD]</span>
                                </td>
                                <td>
                                    #{{ item.ProdID }} - {{ item.ProdName }}
                                </td>
                                <td class="text-right">
                                    {{ item.Antal }}
                                </td>
                                <td class="text-right">
                                    <a
                                        :href="'/batch/list?type=return_order&status_id=' + item.StatusID + '&prod_id=' + item.ProdID + '&yearweek=' + item.vecka"
                                        target="_blank"
                                    >
                                        Lista &#187;
                                    </a>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="4" class="text-center py-5"><i>Inga leveranser...</i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else-if="section === 'returnorders_not_delivered'" class="card">
            <div class="card-header bg-white">
                <h5 class="card-title">Reklamationer - Ej levererade</h5>
            </div>
            <div class="card-body">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" :class="{ 'active': section === 'returnorders_deliveries' }" @click="section = 'returnorders_deliveries'">Leveranser</button>
                    <button type="button" class="btn btn-light" :class="{ 'active': section === 'returnorders_not_delivered' }" @click="section = 'returnorders_not_delivered'">Ej levererade</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-xs">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Orderdatum</th>
                            <th>Kortnummer</th>
                            <th>Namn</th>
                            <th>Önskat Lev. datum</th>
                            <th>Beställd produkt</th>
                            <th>Ordertatus</th>
                        </tr>
                    </thead>
                    <tbody v-if="busy">
                        <tr>
                            <td colspan="4" class="text-center py-5"><i class="icon-spinner2 spinner"></i></td>
                        </tr>
                    </tbody>
                    <tbody v-else-if="returnorders_not_delivered && returnorders_not_delivered.length > 0">
                        <tr v-for="(item, i_index) in returnorders_not_delivered" :key="'ni-' + i_index" style="color: white;" :class="['bg-' + item.Class]">
                            <td>
                                <a
                                    :href="'/returnorders/' + item.ReturnOrderID"
                                    target="_blank"
                                    style="color: white;"
                                >
                                    {{ item.ReturnOrderID }}
                                </a>
                            </td>
                            <td>{{ item.CreatedTS }}</td>
                            <td>
                                <a
                                    :href="'/returnorders/' + item.ReturnOrderID"
                                    target="_blank"
                                    style="color: white;"
                                >
                                    {{ item.CardNo }}
                                </a>
                            </td>
                            <td>{{ item.Name }}</td>
                            <td>{{ item.WantedDeliveryDate }}</td>
                            <td>{{ item.ProdQuantity }} st #{{ item.ProdID }} - {{ item.ProdName }}</td>
                            <td>{{ item.Status }} ({{ item.StatusID }})</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="7" class="text-center py-5"><i>Inga leveranser...</i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="section === 'card_orders'" class="card">
            <div class="card-header bg-white">
                <h5 class="card-title">Ordrar</h5>
            </div>
            <order-list :product-id="parseInt(id)" no-wrapper></order-list>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import { formatDateTime } from '@services/Helpers';
import OrderList from '@app/pages/cardorder/partials/OrderList.vue';

export default {
    name: 'ProductEditorDeliveryStatus',
    components: {
        OrderList,
    },
    props: {
        id: {
            default: 'new',
        },
    },
    created() {
        this.getDeliveries();
    },
    data: () => ({
        busy: true,
        section: 'deliveries',
        deliveries: [],
        not_delivered: [],
        returnorders_deliveries: [],
        returnorders_not_delivered: [],
    }),
    watch: {
        section(newVal) {
            if (newVal === 'deliveries') {
                this.getDeliveries();
            }
            if (newVal === 'not_delivered') {
                this.getNotDelivered();
            }
            if (newVal === 'returnorders_deliveries') {
                this.getRODeliveries();
            }
            if (newVal === 'returnorders_not_delivered') {
                this.getRONotDelivered();
            }
        },
    },
    methods: {
        formatDateTime,
        async getDeliveries() {
            this.busy = true;
            await apiClient.get('/vue/products/' + this.id + '/deliveries')
                .then((response) => {
                    if (response.data) {
                        this.deliveries = response.data;
                    }
                })
                .finally(() => {
                    this.busy = false;
                });
        },
        async getNotDelivered() {
            this.busy = true;
            await apiClient.get('/vue/products/' + this.id + '/not_delivered')
                .then((response) => {
                    if (response.data) {
                        this.not_delivered = response.data;
                    }
                })
                .finally(() => {
                    this.busy = false;
                });
        },
        async getRODeliveries() {
            this.busy = true;
            await apiClient.get('/vue/products/' + this.id + '/returnorders_deliveries')
                .then((response) => {
                    if (response.data) {
                        this.returnorders_deliveries = response.data;
                    }
                })
                .finally(() => {
                    this.busy = false;
                });
        },
        async getRONotDelivered() {
            this.busy = true;
            await apiClient.get('/vue/products/' + this.id + '/returnorders_not_delivered')
                .then((response) => {
                    if (response.data) {
                        this.returnorders_not_delivered = response.data;
                    }
                })
                .finally(() => {
                    this.busy = false;
                });
        },
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
    },
};
</script>
